import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import DatePicker from "react-date-picker";
import Icon from "../icon/Icon";
import { useAuth } from "../authentication/useAuth";

interface DateInputProps {
  name: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
}

const DateInput = (props: DateInputProps) => {
  const { control, getFieldState, formState } = useFormContext();
  const { language } = useAuth();

  const { invalid, isDirty, error } = getFieldState(props.name, formState);

  const showError = !!error && isDirty;

  return (
    <div className="mb-2">
      <Controller
        name={props.name}
        control={control}
        rules={props.options}
        render={({ field }) => (
          <DatePicker
            {...field}
            className={`DateInput w-full ${invalid ? "invalid" : ""} ${props.required ? "required" : ""}`}
            calendarIcon={<Icon name="calendar" size="small" />}
            clearIcon={<Icon name="close" size="small" />}
            locale={language}
          />
        )}
      />
      {showError && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default DateInput;
